import React, { useState, useRef } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import RoadMap from './RoadMap/RoadMap';

import classes from './PharmuniRoadMap.module.scss';


const PharmuniRoadMap = ({position}) => {
    const [value, setValue] = React.useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <div className='container'>
            <div className={classes.wrapper}>
                <h2>Wherever You Are in Pharma,<br /> There's a Smarter Way Forward</h2>
                <p>
                    Choose your current position to see how Pharmuni can accelerate your career growth
                </p>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={value}>
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <TabList
                                className={classes['tab-list']}
                                onChange={handleChange}
                                aria-label="lab API tabs example"
                                centered
                                sx={{
                                    borderBottom: 'none',
                                    '.MuiTabs-indicator': { display: 'none' }
                                }}
                            >
                                 <Tab
                                    label="Professionals"
                                    value="1"
                                    className={value === '1' ? classes['selected'] : ''}
                                />
                                 <Tab
                                    label="Job Seekers"
                                    value="2"
                                    className={value === '2' ? classes['selected'] : ''}
                                />
                                 <Tab
                                    label="Career Changers"
                                    value="3"
                                    className={value === '3' ? classes['selected'] : ''}
                                />
                                <Tab
                                    label="Students"
                                    value="4"
                                    className={value === '4' ? classes['selected'] : ''}
                                />
                               
                               
                            </TabList>
                        </Box>
                        <TabPanel value="1">
                            <RoadMap type="professionals" position={position} />
                        </TabPanel>
                        <TabPanel value="2">
                            <RoadMap type="job_seekers" position={position} />
                        </TabPanel>
                        <TabPanel value="3">
                            <RoadMap type="career_changers" position={position} />
                        </TabPanel>
                        <TabPanel value="4">
                            <RoadMap type="students" position={position} />
                        </TabPanel>
                    </TabContext>
                </Box>
            </div>

        </div>
    );
};

export default PharmuniRoadMap;